import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import Helmet from 'react-helmet';
import OnboardForm from './OnboardForm';
import MinimalFooter from '../common/footer/MinimalFooter';
import { createWedding } from '../../actions/WeddingActions';
import { incStep, decStep, resetStep, setPrimaryProduct, getSlugSuggestions } from '../../actions/OnboardActions';
import { getUserContext } from '../../actions/UserActions';
import stepCopy from './stepCopy';
import { getCookie, deleteCookie } from '../../util/storage';
import { detectMobileDevice } from '../../util/detectBrowser';
import { createProject } from '../../cards/actions/projectActions';
import BottomBlock from './registryOnboardComponents/BottomBlock';
import { trackOnboardingCompleted } from '../../util/trackingHelper';


class CreateFlow extends Component {
  constructor(props) {
    super(props);
    this.clickBack = this.clickBack.bind(this);
    this.fetchSlugAndHandleSubmit = this.fetchSlugAndHandleSubmit.bind(this);
    this.fetchSlugSuggestions = this.fetchSlugSuggestions.bind(this);
  }

  componentWillMount() {
    const { location, setProduct } = this.props;
    const validProductTypes = ['WEDDING_WEBSITE', 'REGISTRY', 'WEDDING_CHECKLIST', 'WEDDING_GUEST_LIST', 'INVITATIONS', 'SAVE_THE_DATE', 'WEDDING_PLANNING'];
    // sets product if query param exists
    const product = location.query.product;
    if (validProductTypes.includes(product)) {
      setProduct(product);
    }
  }

  componentWillUnmount() {
    const { onboardReset } = this.props;
    // reset the step to 1
    onboardReset();
  }

  fetchSlugSuggestions(onboardingData) {
    const { getSuggestions } = this.props;
    const formattedDate = onboardingData.wedding_date ? moment.utc(onboardingData.wedding_date).toDate() : '';

    const slugSuggestionData = {
      primaryFirstName: onboardingData.owner_user_first_name,
      partnerFirstName: onboardingData.partner_user_first_name,
      primaryLastName: onboardingData.owner_user_last_name,
      partnerLastName: onboardingData.partner_user_last_name,
      eventDate: formattedDate
    };
    return getSuggestions(slugSuggestionData);
  }

  // Method for fetching and assigning slug during onboarding.
  // TODO: Remove call to fetch slug suggestion when svc endpoint is ready to receive nullable slugs
  fetchSlugAndHandleSubmit(createWeddingRequest) {
    const { onSubmit, handleGetUserContext, primaryProduct, userContext, onCreateProject } = this.props;
    const onboardingData = createWeddingRequest;
    const onMobile = detectMobileDevice();
    const selectedWebsiteTheme = getCookie('preauthSelectedWeddingTheme');

    this.fetchSlugSuggestions(onboardingData)
      .then((response) => {
        const slug = response.payload[0];
        onboardingData.slug = slug;
      })
      .then(() => onSubmit(onboardingData))
      .then(() => handleGetUserContext())
      .then(() => {
        const isExistingUser = !!userContext.has_registry || !!userContext.has_wedding_account || !!userContext.has_invitation_account || !!userContext.is_inspiration_vendor || !!userContext.has_inspiration_account;
        const newUserInvitesSku = getCookie('newUserInvitesSku').split('|');
        const invitesBusinessComponent = getCookie('invitesBusinessComponent');
        switch (primaryProduct) {
          case 'REGISTRY':
            if (onMobile) {
              window.location.href = '/wedding/mobile-landing';
            // showModalOnChecklist is set by optimizely
            } else if (window.showModalOnChecklist) {
              window.location.href = '/registry/checklist?onboard=true';
            } else {
              window.location.href = '/registry/checklist';
            }
            break;
          case 'WEDDING_WEBSITE':
            if (selectedWebsiteTheme) {
              setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDING_WEBSITE', isExistingUser));
            }
            setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDINGS', isExistingUser));
            browserHistory.push('/wedding/manage/website/designs');
            break;
          case 'WEDDING_CHECKLIST':
          case 'WEDDING_GUEST_LIST':
          case 'WEDDING_PLANNING':
            setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDINGS', isExistingUser));
            browserHistory.push('/wedding/manage');
            break;
          case 'INVITATIONS':
          case 'SAVE_THE_DATE':
            deleteCookie('newUserInvitesSku');
            deleteCookie('invitesBusinessComponent');
            if (newUserInvitesSku.length === 3) {
              // length will only be 3 if created from CardDetailV2 which is for sku migration PDP
              onCreateProject(newUserInvitesSku[0], newUserInvitesSku[1], newUserInvitesSku[2]).then((json) => {
                const { uuid } = json;
                browserHistory.push(`/wedding-planning/custom/${uuid}/detailFront`);
                // check business unit component and fire onboarding completed.
                trackOnboardingCompleted('INVITATIONS', invitesBusinessComponent, isExistingUser);
              });
            } else {
              // redirect if neither of the above criteria match
              if (primaryProduct === 'SAVE_THE_DATE') {
                browserHistory.push('/wedding-planning/save-the-date/shop');
                break;
              }
              browserHistory.push('/wedding-planning/invitations/shop');
            }
            break;
          default:
            // Something went wrong so let's go to the homepage for help redirecting
            window.location.href = '/';
        }
      });
  }

  clickBack() {
    const { step, onPrevious } = this.props;
    if (step === 1) {
      window.location = document.referrer;
    } else {
      onPrevious();
    }
  }

  render() {
    const { step, onNext, onPrevious, primaryProduct } = this.props;

    const onRegistry = primaryProduct === 'REGISTRY';

    // Set steps
    const steps = [1, 2];

    // Get copy overrides
    let overrideCopy = [];
    if (stepCopy[primaryProduct]) {
      overrideCopy = stepCopy[primaryProduct];
    }

    return (
      <div id="unified-onboard">
        <Helmet
          style={[
            {
              type: 'text/css',
              cssText: ` html, .main-content {
                background: #FCFCFC;
              }
              body {
                margin-bottom: 75px;
              }`
            }
          ]}
        />
        <header className="onboard-header">
          <span role="button" onClick={this.clickBack} className="onboard-header-back">
            &lsaquo;
          </span>
          <div className="logo-weddings" />
        </header>
        <div className="main-content">
          <div className="onboard_back-button-cont clearfix hidden-xs">
            <button onClick={this.clickBack} className="btn btn-secondary">
              <i className="glyphicon glyphicon-menu-left" /> Back
            </button>
          </div>
          <div className="container text-center">
            <OnboardForm
              step={step}
              onNext={onNext}
              onPrevious={onPrevious}
              onSubmit={this.fetchSlugAndHandleSubmit}
              steps={steps}
              overrideCopy={overrideCopy}
              primaryProduct={primaryProduct}
            />
          </div>
          {onRegistry && [1, 2].indexOf(step) >= 0 && (
            <BottomBlock step={step} />
          )}
        </div>
        <MinimalFooter />
      </div>
    );
  }
}

CreateFlow.propTypes = {
  step: PropTypes.number,
  location: PropTypes.shape({}),
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  onSubmit: PropTypes.func,
  setProduct: PropTypes.func,
  handleGetUserContext: PropTypes.func,
  onboardReset: PropTypes.func,
  primaryProduct: PropTypes.string,
  getSuggestions: PropTypes.func.isRequired,
  onCreateProject: PropTypes.func.isRequired,
  userContext: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  step: state.Onboard.step,
  primaryProduct: state.Onboard.primaryProduct,
  userContext: state.user.userContext
});

const mapDispatchToProps = dispatch => ({
  onNext: () => {
    dispatch(incStep());
  },
  onPrevious: () => {
    dispatch(decStep());
  },
  onboardReset: () => {
    dispatch(resetStep());
  },
  setProduct: (primaryProductKey) => {
    dispatch(setPrimaryProduct(primaryProductKey));
  },
  onSubmit: createWeddingRequest => dispatch(createWedding(createWeddingRequest)),
  handleGetUserContext: () => dispatch(getUserContext()),
  getSuggestions: slugSuggestionData => dispatch(getSlugSuggestions(slugSuggestionData)),
  onCreateProject: (suiteUUID, activeVariationUUID, quantity) => dispatch(createProject(suiteUUID, activeVariationUUID, quantity)),
});

const CreateFlowContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateFlow);

export default CreateFlowContainer;



// WEBPACK FOOTER //
// ./src/components/onboard/CreateFlow.jsx